<template>
    <admin-layout>
        <section class="px-4 md:px-5 py-4 md:py-7 space-y-7">
            <custom-info-header icon="iconoir:whatsapp" title="WhatsApp"
                description="Connect your metad account to use the API">
                <template v-slot:action>
                    <custom-router-link label="Set Up" size="md" :to="{ name: 'configurationWhatsappSetup' }" />
                </template>
            </custom-info-header>
            <article class="mt-10">
                <custom-table 
                    :headers="[
                        'Phone',
                        'Account Id',
                        'Created Date',
                        ''
                    ]" 
                    :loading="{
                        isLoading: isLoading,
                        barRows: 6,
                        barCols: 3
                    }" 
                    :isEmpty="!isLoading && configurations.length <= 0">
                    <template v-slot:body>
                        <tr v-for="configuration in configurations" :key="configuration.id"
                            class="h-16 border-t border-gray-100 rounded">
                            <custom-table-td>
                                <router-link :to="{ name: 'updateContact', params: { guid: configuration.guid } }"
                                    class="text-blue-600 flex items-center gap-1 hover:underline">
                                    <em class="not-italic">{{ configuration.phone }}</em>
                                    <Icon icon="lucide:external-link" />
                                </router-link>
                            </custom-table-td>
                            <custom-table-td>{{ configuration.accountId }}</custom-table-td>
                            <custom-table-td>{{ formatDate(configuration.createdDate) }}</custom-table-td>
                            <custom-table-td type="template">
                                <custom-dropdown placement="right">
                                    <template v-slot:button>
                                        <button class="flex px-5 py-3 rounded-md bg-transparent text-gray-500">
                                            <Icon icon="mingcute:more-2-fill" class="text-xl" />
                                        </button>
                                    </template>
                                    <template v-slot:content>
                                        <section>
                                            <custom-dropdown-item type="link" label="Update"
                                                :to="{ name: 'updateContact', params: { guid: configuration.guid } }" />
                                        </section>
                                    </template>
                                </custom-dropdown>
                            </custom-table-td>
                        </tr>
                    </template>
                </custom-table>
            </article>
        </section>
    </admin-layout>
</template>

<script setup>
import { onMounted } from 'vue';
import { Icon } from "@iconify/vue";
import AdminLayout from '@/app/layouts/AdminLayout'
import CustomInfoHeader from '@/app/components/CustomInfoHeader'
import CustomTable from '@/app/components/CustomTable';
import CustomTableTd from '@/app/components/CustomTableTd'
import CustomDropdown from '@/app/components/CustomDropdown'
import CustomRouterLink from '@/app/components/CustomRouterLink'
import { formatDate } from '@/core/helper/utility.js'
import { useWhatsappConfiguration } from '@/core/composables/useWhatsappConfiguration'

const {
    isLoading,
    configurations,
    getWhatsappConfigurations
} = useWhatsappConfiguration();

onMounted(async () => {
    await getWhatsappConfigurations();
})
</script>